import React from "react";

export default function KapcsolatPage() {
  return (
    <div className="p-6 max-w-4xl mx-auto space-y-8">
      <h1 className="text-3xl font-bold mb-4">Kapcsolat</h1>

      {/* Cégadatok */}
      <section>
        <h2 className="text-xl font-semibold mb-2">Cégadatok</h2>
        <p><strong>Cégnév:</strong> Solarya Tech&amp;Garden Kft.</p>
        <p><strong>Székhely:</strong> 2112 Veresegyház, Szent Erzsébet körút 42.</p>
        <p><strong>Adószám:</strong> 12345678-1-42</p>
        <p><strong>Cégjegyzékszám:</strong> 01-09-999999</p>
      </section>

      {/* Elérhetőség */}
      <section>
        <h2 className="text-xl font-semibold mb-2">Elérhetőség</h2>
        <p><strong>Telefon:</strong> +36 30 123 4567</p>
        <p><strong>E-mail:</strong> info@solarya.hu</p>
        <p><strong>Nyitvatartás:</strong><br/>
          H–P: 9:00–17:00<br/>
          Sz: 10:00–14:00<br/>
          V: Zárva
        </p>
      </section>

      {/* Térkép */}
      <section>
        <h2 className="text-xl font-semibold mb-2">Térkép</h2>
        <div className="w-full h-64">
          <iframe
            title="Térkép"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2747.768893073857!2d19.28560101558924!3d47.64903889154433!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4741dbeedec3f1a9%3A0xd0d113e1789b5ff2!2sVeresegyh%C3%A1z%2C%20Szent%20Erzs%C3%A9bet%20k%C3%B6r%C3%BAt%2042!5e0!3m2!1shu!2shu!4v1720400000000"
            width="100%"
            height="100%"
            allowFullScreen=""
            loading="lazy"
            className="rounded shadow"
          ></iframe>
        </div>
      </section>

      {/* Üzenetküldő űrlap */}
      <section>
        <h2 className="text-xl font-semibold mb-2">Írj nekünk</h2>
        <form className="space-y-4">
          <input
            type="text"
            placeholder="Név"
            className="w-full border px-4 py-2 rounded"
          />
          <input
            type="email"
            placeholder="E-mail"
            className="w-full border px-4 py-2 rounded"
          />
          <textarea
            placeholder="Üzenet"
            rows="5"
            className="w-full border px-4 py-2 rounded"
          ></textarea>
          <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
            Küldés
          </button>
        </form>
      </section>

      {/* Közösségi ikonok */}
      <section>
        <h2 className="text-xl font-semibold mb-2">Kövess minket</h2>
        <div className="flex gap-4 text-2xl">
          <a href="#" className="hover:text-blue-500">📘</a>
          <a href="#" className="hover:text-pink-500">📸</a>
          <a href="#" className="hover:text-red-500">▶️</a>
        </div>
      </section>
    </div>
  );
}
